import moment from 'jalali-moment';
import * as Yup from 'yup';

export const storeTypes = [
  {
    id: 1,
    image: 'https://my-store.s3.ir-thr-at1.arvanstorage.ir/dokan.svg',
    title: 'دکان',
    desc: 'کود، سم، بذر و نهال، ابزار و تجهیزات',
  },
  {
    id: 2,
    image: 'https://my-store.s3.ir-thr-at1.arvanstorage.ir/khish.svg',
    title: 'خیش',
    desc: 'ماشین آلات و خدمات مکانیزاسیون',
  },
  {
    id: 3,
    image: 'https://my-store.s3.ir-thr-at1.arvanstorage.ir/nasagh.svg',
    title: 'نسق',
    desc: 'اجاره و فروش زمین',
  },
  {
    id: 4,
    image: 'https://my-store.s3.ir-thr-at1.arvanstorage.ir/bone.svg',
    title: 'بُنه',
    desc: 'کارگر و کارشناس',
  },
  {
    id: 5,
    image: 'https://my-store.s3.ir-thr-at1.arvanstorage.ir/laboratory.svg',
    title: 'آزمایشگاه',
    desc: 'آب و خاک، گیاه، دام، کود و سم',
    guid: 'c2ba2c7b-04ad-4b7a-a510-c0989afcf2e5',
  },
];

export const switchButtonData = [
  {
    id: '1',
    title: 'امکان مراجعه حضوری به فروشگاه',
    name: 'in_person_possibility',
  },
  {id: '2', title: 'امکان ارسال کالا', name: 'has_delivery'},
  {id: '3', title: 'ضمانت کیفیت', name: 'has_guarantee'},
];

export const stepperData = [
  {id: 1, label: 'انتخاب نوع فروشگاه'},
  {id: 2, label: 'مشخصات مالک'},
  {id: 3, label: 'مشخصات فروشگاه', isActive: true},
];

export const TypeStoreSchema = Yup.object().shape({
  name: Yup.string().required('نام و نام خانوادگی را وارد کنید'),
  image: Yup.object().shape({
    file: Yup.mixed().required('تصویر را بار گذاری کنید'),
  }),
});

export const OwnerDetailSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('نام و نام خانوادگی الزامی است'),
  });
};

export const storeDetailSchema = Yup.object().shape({
  title: Yup.string().required('نام فروشگاه را وارد کنید.'),
  about: Yup.string().required('درباره فروشگاه خود توضیحی بنویسید.'),
  land_line: Yup.string()
    .matches(/^\d+$/, 'فقط اعداد مجاز هستند') // Ensures only digits
    .min(10, 'شماره نباید کمتر از 10 رقم باشد') // Minimum length of 10 digits
    .max(11, 'مقدار نباید بیشتر از 11 رقم باشد'),
});
export const labDetailSchema = Yup.object().shape({
  title: Yup.string().required('نام آزمایشگاه را وارد کنید.'),
  about: Yup.string().required('درباه آزمایشگاه خود توضیحی بنویسید.'),
  certificate: Yup.array()
    .required('گواهی و اعتبار نامه ها اجباری است')
    .min(1, 'گواهی و اعتبار نامه ها اجباری است'),
});

export const shopCertificate = [
  {
    id: 'ivo',
    code: '5',
    title: 'دام پزشکی',
    image: 'https://store-certificate.s3.ir-thr-at1.arvanstorage.ir/ivo.svg',
  },
  {
    id: 'iso',
    code: '3',
    title: 'ایزو',
    image: 'https://store-certificate.s3.ir-thr-at1.arvanstorage.ir/iso.svg',
  },
  {
    id: 'inso',
    code: '2',
    title: 'سازمان ملی استاندارد',
    image: 'https://store-certificate.s3.ir-thr-at1.arvanstorage.ir/inso.svg',
  },
  {
    id: 'fda',
    code: '4',
    title: 'غذا و دارو',
    image: 'https://store-certificate.s3.ir-thr-at1.arvanstorage.ir/fda.svg',
  },
  {
    id: 'doe',
    code: '1',
    title: 'محیط زیست',
    image: 'https://store-certificate.s3.ir-thr-at1.arvanstorage.ir/doe.svg',
  },
];

export function getJalaliWeek(date: string) {
  const jalaliDate = moment(date).locale('fa').format('jYYYY-jMM-jDD');

  const startOfYear = moment(jalaliDate, 'jYYYY-jMM-jDD').startOf('jYear');
  const weekNumber =
    Math.ceil(
      moment(jalaliDate, 'jYYYY-jMM-jDD').diff(startOfYear, 'days') / 7,
    ) + 1;
  return weekNumber;
}
export const monthDate = (date: string) => {
  return moment(date, 'YYYY-MM-DD').locale('fa').format('jMMMM jYYYY');
};

interface IcustomToolTip {
  value: IStoreView;
}
export const customToolTip = ({value}: IcustomToolTip) => {
  const jalaliDate = moment(value.date).locale('fa');
  return `${jalaliDate.format('jDD jMMMM jYYYY')}
    ${value.view_quantity} بازدید`;
};

export const monthagoLabels: Record<string, string> = {
  1: 'هفته اول',
  2: 'هفته دوم',
  3: 'هفته سوم',
  4: 'هفته چهارم',
};

export const handleMenulList = (assigner_store: string) => {
  const store = [
    {
      id: 1,
      title: 'قرارداد مشارکت در فروش',
      icon: 'icon-Report-List',
      route: `/my-store-sales-partnership-agreement`,
    },
    {
      id: 2,
      title: 'سفارش های ثبت شده',
      icon: 'icon-size2425',
      route: `/my-store-orders`,
    },
    {
      id: 3,
      title: 'آگهی‌های فروشگاه  من',
      icon: 'icon-namespeaker-2',
      route: `/manage-my-store-ads`,
    },
    {
      id: 4,
      title: 'ارتقا فروشگاه',
      icon: 'icon-nameBar-chart-upward',
      route: '/account/promotion/store',
    },
    {
      id: 5,
      title: 'برند های من',
      icon: 'icon-nameshops',
      route: '/my-store-brands',
    },
    {
      id: 6,
      title: 'عاملین فروش من',
      icon: 'icon-nameshops',
      route: `/my-store-sale-agents`,
    },
    {
      id: 7,
      title: 'تسویه و واریز ها',
      icon: 'icon-nameWallet-income',
      route: `/settlementAndPayouts`,
    },
    {
      id: 8,
      title: 'تبلیغات و برندینگ هوشمند',
      icon: 'icon-money-bag',
      route: `/sponsor/activePlane`,
    },
    {
      id: 9,
      title: 'ارتباط با پشتیبانی',
      icon: 'icon-namesupport',
      route: '/backup',
    },
  ];
  const lab = [
    {
      id: 1,
      title: 'آگهی‌های آزمایشکاه من',
      icon: 'icon-namespeaker-2',
      route: `/my-lab-Advertisement/${assigner_store}`,
    },
    {
      id: 2,
      title: 'ارتقا آزمایشگاه',
      icon: 'icon-nameBar-chart-upward',
      route: '/account/promotion/lab',
    },
    {
      id: 3,
      title: 'ارتباط با پشتیبانی',
      icon: 'icon-namesupport',
      route: '/backup',
    },
  ];

  return {store, lab};
};

export const myStoreFiltersData = [
  {id: '1', title: 'جدیدترین', value: 'lastest'},
  {id: '2', title: 'پربازدیدترین', value: 'most_viewed'},
  {id: '3', title: 'ارزان‌ترین', value: 'cheapest'},
  {id: '4', title: 'گران‌ترین', value: 'most_expensive'},
  {id: '5', title: 'نزدیک ترین ', value: 'nearest'},
];
export const myStoreMultiSelectData = [
  {
    id: '1',
    title: 'در انتظار تایید ',
    value: 'pending',
  },
  {
    id: '2',
    title: 'رد شده',
    value: 'rejected',
  },
  {
    id: '3',
    title: 'منقضی شده',
    value: 'expired',
  },
  {
    id: '4',
    title: 'ارتقا یافته',
    value: 'promoted',
  },
];

export const my_store_input_groups: Array<
  Omit<IInputGroup, 'title_description' | 'icon'>
> = [
  {
    image:
      'https://my-store-input-groups.s3.ir-thr-at1.arvanstorage.ir/all%20.svg',
    guid: '1',
    title: 'همه',
    code: 0,
    type: 'all',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/feritilizer.svg',
    guid: '76025755-7d12-47f7-9673-35f3fb91444c',
    title: 'کود',
    code: 11,
    type: 'fertilizer',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/poision.svg',
    guid: '809bd49b-5d3d-44c9-9a35-7b2928163796',
    title: 'سم',
    code: 12,
    type: 'pesticide',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/seed.svg',
    guid: '4c55f128-0fea-4cdd-bee6-a72cbf87173a',
    title: 'بذر و نهال',
    code: 13,
    type: 'seed',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/tools.svg',
    guid: '2f85d3e8-52f5-4c8a-9eb3-d715c2eedeb8',
    title: 'ابزار و تجهیزات',
    code: 16,
    type: 'tool',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/machinery.svg',
    guid: '2bf80ac2-d181-4444-8820-b545e7b7ffad',
    title: 'ماشین آلات',
    code: 15,
    type: 'machinery',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/farm.svg',
    guid: '98f932a1-0c39-4892-90e8-961b472a1fd6',
    title: 'مزرعه و آب',
    code: 17,
    type: 'farm',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/employee.svg',
    guid: 'cd504631-0f3a-4c12-93fe-87cd8d56e92a',
    title: 'کار کشاورزی',
    code: 14,
    type: 'employee',
  },
  {
    image: 'https://input-groups.s3.ir-thr-at1.arvanstorage.ir/lab.svg',
    guid: 'c2ba2c7b-04ad-4b7a-a510-c0989afcf2e5',
    title: 'آزمایشگاه',
    type: 'lab',
    code: 18,
  },
];

export const rate = [
  {id: 5, title: 'عالی'},
  {id: 4, title: 'خیلی خوب'},
  {id: 3, title: 'خوب'},
  {id: 2, title: 'معمولی'},
  {id: 1, title: 'بد'},
];

export const storyValidateSchema = Yup.object().shape({
  link_description: Yup.string()
    .required('عنوان  اجباری می باشد')
    .max(45, 'عنوان نمی تواند بیشتر از 45 کاراکتر باشد.'),
  link: Yup.string().required('لینک اجباری می باشد'),
});

export const labValueOptionalForm = (optionalRegisterFormData?: string) => {
  const initialValue: Record<
    string,
    string | number | undefined | Record<string, string | number | undefined>
  > = {
    ...(optionalRegisterFormData && JSON.parse(optionalRegisterFormData)),
  };

  return initialValue;
};

export const saleAgnentValidationSchema = Yup.object().shape({
  phone_number: Yup.string()
    .required('تلفن همراه را وارد کنید')
    .max(11, 'شماره تلفن همراه صحیح نیست')
    .min(11, 'شماره تلفن همراه صحیح نیست'),
  name: Yup.string().required('نام فروشگاه را وارد کنید'),
});

export const storeCodeToName: {[key: number]: string} = {
  110: 'dokan',
  120: 'lab',
  130: 'khish',
  140: 'nasagh',
  150: 'bone',
};

export const getStoreName = (code: number): string | undefined => {
  return storeCodeToName[code];
};
